<template>
  <div class="news-center-page">
    <Banner :bannerUrl="bannerUrl" :title="$t('newsCenterPage.newsCenter')" />
    <div class="container">
      <h2 class="com-top-tile">{{ $t('newsCenterPage.huanshuntongNews') }}</h2>
      <newsList/>
    </div>
  </div>
</template>

<script setup>
  import Banner from '@/components/banner'
  import newsList from '@/components/newsList/index.vue'
  const bannerUrl = require('@assets/images/banner/banner-news-center.png');
</script>

<style lang="less" scoped>
.news-center-page {
  margin-bottom: 97px;
  h2 {
    margin-top: 80px;
    margin-bottom: 53px;
  }
  
}
</style>